import { StatusValue } from '../../shared/types';

interface MessageMap<T> {
    [key: string]: T;
}

export interface SyntheticVerificationMap {
    name: string;
    description: string;
    status: StatusValue;
}

export const synthReasonMapY: MessageMap<SyntheticVerificationMap> = {
    sharedSsn: {
        name: 'Shared SSN',
        description: 'SSN is found to be associated to more than one person.',
        status: StatusValue.Failed
    },
    verifiedSsn: {
        name: 'SSN Verified',
        description: 'SSN is verified through comparison to credit data.',
        status: StatusValue.Passed
    },
    invalidSsn: {
        name: 'Invalid SSN',
        description: 'SSN contains obvious errors.',
        status: StatusValue.Failed
    },
    sharedAddress: {
        name: 'Shared Address',
        description: 'Address is shared with too many credit consumers in most recent 3 months.',
        status: StatusValue.Failed
    },
    identityConfirmation1: {
        name: 'Identity Confirmation 1',
        description: "Applicant's name matches to property owner.",
        status: StatusValue.Passed
    },
    identityConfirmation2: {
        name: 'Identity Confirmation 2',
        description: "Applicant's name is consistent to household information to the address.",
        status: StatusValue.Passed
    },
    inquiry: {
        name: 'Inquiry',
        description: 'Risky inquiry patterns related to credit monitoring checks are detected.',
        status: StatusValue.Failed
    },
    deathMasterHit: {
        name: 'Death Master Hit',
        description: 'SSN is found in the SSA Death Master File.',
        status: StatusValue.Failed
    }
};

export const synthReasonMapN: MessageMap<SyntheticVerificationMap> = {
    sharedSsn: {
        name: 'Shared SSN',
        description: 'SSN is not associated to more than one person.',
        status: StatusValue.Passed
    },
    verifiedSsn: {
        name: 'SSN Verified',
        description: 'SSN is not verified.',
        status: StatusValue.Failed
    },
    invalidSsn: {
        name: 'Invalid SSN',
        description: "SSN doesn't contain obvious errors.",
        status: StatusValue.Passed
    },
    sharedAddress: {
        name: 'Shared Address',
        description: 'Address is not shared with too many credit consumers in most recent 3 months.',
        status: StatusValue.Passed
    },
    identityConfirmation1: {
        name: 'Identity Confirmation 1',
        description: "Applicant's name doesn't match to property owner.",
        status: StatusValue.Failed
    },
    identityConfirmation2: {
        name: 'Identity Confirmation 2',
        description: "Applicant's name is not consistent to household information to the address.",
        status: StatusValue.Failed
    },
    inquiry: {
        name: 'Inquiry',
        description: 'Risky inquiry patterns related to credit monitoring checks are not detected.',
        status: StatusValue.Passed
    },
    deathMasterHit: {
        name: 'Death Master Hit',
        description: 'SSN is not found in the SSA Death Master File.',
        status: StatusValue.Passed
    }
};

export const synthReasonMapU: MessageMap<SyntheticVerificationMap> = {
    sharedSsn: {
        name: 'Shared SSN',
        description: 'Less than 9 digits SSN provided.',
        status: StatusValue.Undetermined
    },
    verifiedSsn: {
        name: 'SSN Verified',
        description: 'Less than 9 digits SSN provided.',
        status: StatusValue.Undetermined
    },
    invalidSsn: {
        name: 'Invalid SSN',
        description: 'Less than 9 digits SSN provided.',
        status: StatusValue.Undetermined
    },
    sharedAddress: {
        name: 'Shared Address',
        description: 'There is no information available on Equifax data sources to risk assess.',
        status: StatusValue.Undetermined
    },
    identityConfirmation1: {
        name: 'Identity Confirmation 1',
        description: 'Address is not found to be a consumer owned property.',
        status: StatusValue.Undetermined
    },
    identityConfirmation2: {
        name: 'Identity Confirmation 2',
        description: "Applicant's address is not found in secondary Equifax data source.",
        status: StatusValue.Undetermined
    },
    inquiry: {
        name: 'Inquiry',
        description: 'There is no information available on Equifax data sources to risk assess.',
        status: StatusValue.Undetermined
    },
    deathMasterHit: {
        name: 'Death Master Hit',
        description: 'SSN is not provided in consumer Applicant PII input.',
        status: StatusValue.Undetermined
    }
};
